import React, { Component } from 'react';
import styles from './style.module.css';

export default class FixedHeading extends Component {
    state = {
        fixed: false
    };

    componentDidMount = () => {
        window.addEventListener('scroll', this.handleScroll);
    };

    componentWillUnmount = () => {
        window.removeEventListener('scroll', this.handleScroll);
    };

    handleScroll = () => {
        const anchor = document.querySelector('#fixedHeading');
        const anchorPosition = anchor.getBoundingClientRect();
        const anchorTop = anchorPosition.top;

        this.setState({
            fixed: anchorTop <= 100
        });
    };

    render() {
        const {
            props: {
                title = '',
                content = ''
            },
            state: {
                fixed
            }
        } = this;

        return (
            <div id='fixedHeading'>
                <div className={fixed ? styles.fixedHeadingActive : styles.fixedHeading}>
                    <div className={styles.container}>
                        <h1 className={styles.title}>{title}</h1>
                        <p className={styles.text}>{content}</p>
                    </div>
                </div>
            </div>
        );
    }
}

